// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"wrapper vignette intro-frame\">\n  "
    + ((stack1 = ((helper = (helper = helpers.video || (depth0 != null ? depth0.video : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"video","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n  <div class=\"content\">\n    <div class=\"icon-lego\"></div>\n    <button class=\"btn icon-play\" id=\"continue\"></button>\n  </div>\n</div>";
},"useData":true});
